import { apiFetch } from 'services/apiClient';
import { Page } from '../../../types/Page';
import { CreatePlanningReservationDto, PlanningReservation } from '../types/PlanningReservation';

export const listPlanningReservations = (
  page = 0,
  size = 10,
  sort?: string,
  query?: string,
): Promise<Page<PlanningReservation>> =>
  apiFetch(
    `/planning-reservations?page=${page}&size=${size}` +
      (sort ? `&sort=${sort}` : '') +
      (query ? `&${query}` : ''),
  );

export const listPlanningReservationsAll = (query?: string): Promise<PlanningReservation[]> =>
  apiFetch('/planning-reservations/all' + (query ? `?${query}` : ''));

export const listPlanningReservationsByRange = (
  startDate: string,
  endDate: string,
  accountId?: number,
): Promise<PlanningReservation[]> => {
  const params = new URLSearchParams({
    startDate,
    endDate,
  });
  if (accountId !== undefined) {
    params.append('accountId', String(accountId));
  }
  return apiFetch('/planning-reservations/range?' + params.toString());
};

export const getPlanningReservation = (id: number): Promise<PlanningReservation> =>
  apiFetch('/planning-reservations/' + id);

export const createPlanningReservation = (data: CreatePlanningReservationDto): Promise<PlanningReservation> =>
  apiFetch('/planning-reservations', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });

export const updatePlanningReservation = (id: number, data: any): Promise<PlanningReservation> =>
  apiFetch('/planning-reservations/' + id, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });

export const deletePlanningReservation = (id: number): Promise<void> =>
  apiFetch('/planning-reservations/' + id, { method: 'DELETE' });
